const ua = navigator.userAgent.toLowerCase();
export const isSP = ua.match(/iphone|android.+mobile/);
export const isPad = !isSP && ua.match(/ipad|android/);
export const deviceType = isSP ? "SP" : isPad ? "Pad" : "PC";
export const isAndroid = ua.match(/android/);

if (navigator.userAgent.indexOf("Android") > 0) {
    let body = document.body;
    body.classList.add("Android");
}

export const imgPath = "./assets";

const shareURLEncoded = "https%3A%2F%2Fwww.bunshun.co.jp%2F100th%2F";
const shareTextEncorded = `%E3%83%96%E3%83%B3%E3%82%B7%E3%83%A5%E3%83%B3%E3%81%8C%E5%85%A8%E7%A4%BE%E3%82%92%E6%8C%99%E3%81%92%E3%81%9F%E5%88%9D%E3%81%AE%E3%82%AA%E3%83%B3%E3%83%A9%E3%82%A4%E3%83%B3%E3%83%BB%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E3%81%A7%E3%80%81%E3%82%A4%E3%83%81%E6%8A%BC%E3%81%97%E3%83%A1%E3%83%B3%E3%83%90%E3%83%BC%E3%81%8C%E5%A4%A7%E9%9B%86%E5%90%88%E3%80%82%0A%E3%81%AA%E3%81%AB%E3%81%8C%E8%B5%B7%E3%81%93%E3%82%8B%E3%81%8B%E4%BA%88%E6%B8%AC%E4%B8%8D%E8%83%BD%E3%81%AA2%E6%97%A5%E9%96%93%E3%82%B9%E3%83%9A%E3%82%B7%E3%83%A3%E3%83%AB%EF%BC%81%0A2022%E5%B9%B412%E6%9C%889%E6%97%A5%28%E9%87%91%29%E3%83%BB10%E6%97%A5%28%E5%9C%9F%29YouTube%E3%81%AB%E3%81%A6LIVE%E9%85%8D%E4%BF%A1%EF%BC%81%0A%23%E6%96%87%E6%98%A5100%E5%91%A8%E5%B9%B4%E3%83%95%E3%82%A7%E3%82%B9%0A${shareURLEncoded}`;
export const twShareLink = `https://twitter.com/intent/tweet?text=${shareTextEncorded}`;
export const fbSshareLink = `https://www.facebook.com/sharer/sharer.php?u=${shareURLEncoded}`;
export const lnSshareLink = `http://line.me/R/msg/text/?${shareTextEncorded}`;
